import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import EditForm from '../../../../../../features/components/Forms/EditForm'
import Dv360CustomAgeRanges from '../../../../reusableFormFields/Dv360CustomAgeRanges'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { useEditSectionFormSubmit } from '../../../../../../hooks/formHooks/useEditSectionFormSubmit'
import { getAgeRangesIds } from './helpers'

import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'
import {
  dv360BulkTargetingWasUpdatedSelector,
  dv360TargetingSelector,
  updateDv360BulkTargetingErrorSelector,
  updateDv360BulkTargetingIsLoadingSelector
} from '../../../../../../modules/selectors/dv360Constants'
import {
  clearUpdateDv360BulkTargeting,
  updateDv360BulkTargeting
} from '../../../../../../modules/actions/dv360Constants'

import { HISTORY_META_EDIT_SECTION, TYPE_LINE_ITEM } from '../../../../../../constants/changeHistory'
import { targetingTypes } from '../../../LineItemDv360Create/fields'
import { getInitialValues, validationSchema } from './fields'

function AgesSectionForm({ editItemData: item, title, ...formProps }) {
  const dispatch = useDispatch()

  const targeting = useSelector(dv360TargetingSelector)
  const dv360BulkTargetingWasUpdated = useSelector(dv360BulkTargetingWasUpdatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const initialValues = useMemo(() => {
    return getInitialValues(targeting)
  }, [targeting])

  const handleSubmit = useCallback(
    values => {
      const ageRangesIds = getAgeRangesIds(values)

      const requests = [
        {
          targeting_type: targetingTypes.TARGETING_TYPE_AGE_RANGE,
          assigned_targeting_options: ageRangesIds.map(ageRange => ({
            age_range: ageRange
          }))
        }
      ]

      const updateData = {
        account: selectedAdAccountId,
        line_item_id: item.id,
        requests,
        meta: {
          [HISTORY_META_EDIT_SECTION]: title,
          override: {
            item_id: item.id,
            item_type: TYPE_LINE_ITEM,
            action: 'update'
          }
        }
      }

      dispatch(updateDv360BulkTargeting(updateData, true))
    },
    [dispatch, item.id, selectedAdAccountId, title]
  )

  const { onSubmit, manualSuccessSubmit } = useEditSectionFormSubmit({ initialValues, handleSubmit })

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const handleClearUpdateItem = useCallback(() => {
    dispatch(clearUpdateDv360BulkTargeting())
  }, [dispatch])

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={manualSuccessSubmit || dv360BulkTargetingWasUpdated}
      clearEditItem={handleClearUpdateItem}
      errorSelector={updateDv360BulkTargetingErrorSelector}
      isLoadingSelector={updateDv360BulkTargetingIsLoadingSelector}
      {...formProps}
    >
      <Dv360CustomAgeRanges formik={purifiedFormik} />
    </EditForm>
  )
}

export default AgesSectionForm
